import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { getViewportLabel } from 'libs.irb.common';
import { Dropdown } from 'libs.nucleus';
export const DeviceSelection = ({ onDeviceSelection, useSimplifiedWebLabels = false }) => {
    const [selectedDevice, setSelectedDevice] = useState('web');
    const allDevices = useMemo(() => ({
        web: { width: 375, height: 812, scale: 1, modality: 'web' },
        ipad: { width: 810, height: 1010, scale: 1, modality: 'web' },
        ipadLandscape: { width: 1010, height: 810, scale: 1, modality: 'web' },
        desktopl: { width: 1366, height: 768, scale: 1, modality: 'web' },
        galaxya51: { width: 412, height: 915, scale: 1, modality: 'android' },
    }), []);
    const devices = useMemo(() => {
        if (!useSimplifiedWebLabels) {
            return allDevices;
        }
        return Object.fromEntries(Object.entries(allDevices).filter(([, device]) => device.modality === 'web'));
    }, [allDevices, useSimplifiedWebLabels]);
    useEffect(() => {
        const dev = devices[selectedDevice];
        const viewport = { width: dev.width, height: dev.height, scale: dev.scale };
        onDeviceSelection(dev.modality, viewport);
    }, [selectedDevice, devices, onDeviceSelection]);
    const dropItems = useMemo(() => Object.keys(devices).map((deviceKey) => {
        const dev = devices[deviceKey];
        const label = getViewportLabel({ width: dev.width, height: dev.height, scale: dev.scale }, dev.modality, {
            useSimplifiedWebLabels,
        });
        return {
            id: deviceKey,
            content: (_jsxs("div", { className: 'flex gap-2 w-full justify-between', children: [_jsx("span", { children: label }), _jsxs("small", { className: 'text-secondary', children: [dev.width, " x ", dev.height] })] })),
            onClick: () => setSelectedDevice(deviceKey),
            className: 'nucleus-w-input-lg',
        };
    }), [devices, useSimplifiedWebLabels]);
    // derive selected label via common utility
    const selected = devices[selectedDevice];
    const selectedLabel = getViewportLabel({ width: selected.width, height: selected.height, scale: selected.scale }, selected.modality, { useSimplifiedWebLabels });
    return _jsx(Dropdown, { items: dropItems, label: selectedLabel, width: 'lg' });
};
